import { ITimer } from "../../models/timer";
export const TimerState: ITimer = {
  serverTime: 0,
};
